/**
 * Arrendamiento ganadero pactado en kilos de hacienda por hectárea al año y
 * pagado en pesos al precio de referencia (sección de /precios). Funciones
 * puras: web, render estático y tests.
 */
import type { CategoryPrices } from '../libs/publicPricesSnapshot';

/** Promedio por kilo de una categoría: media de sus rangos de peso con precio. */
export function promedioPorKg(cat: CategoryPrices | undefined): number | null {
  const valores = Object.values(cat?.perkg ?? {})
    .map((p) => p.average)
    .filter((v) => v > 0);
  return valores.length ? valores.reduce((s, v) => s + v, 0) / valores.length : null;
}

export interface Arrendamiento {
  kgTotales: number;
  montoAnual: number;
  montoPorHa: number;
}

/** Kilos por hectárea × hectáreas × precio por kilo. Null si falta algún dato. */
export function calcularArrendamiento(
  kgPorHa: number,
  hectareas: number,
  precioKg: number | null,
): Arrendamiento | null {
  if (!(kgPorHa > 0) || !(hectareas > 0) || !precioKg || !(precioKg > 0)) return null;
  const kgTotales = kgPorHa * hectareas;
  return { kgTotales, montoAnual: kgTotales * precioKg, montoPorHa: kgPorHa * precioKg };
}
